<template>
  <div ref="ContentBoxVideoAssetWrapper" class="content-box-video-asset-wrapper lg:py-6">
    <div
      data-test-id="block-content"
      class="relative mx-auto transition-opacity duration-500 ease-in-out-quart select-none pointer-events-none"
      :class="{ 'opacity-0': !isVisible, [aspectRatioClass]: hasAspectRatioClass }"
    >
      <MajorityUiMajorityImage
        v-if="staticImage"
        :src="optimizedImage"
        alt="static image"
        lazy
        fade-in
        class="block w-full"
        :class="{ [imgClass]: true, 'no-video': !hasVideo, 'absolute centralize': hasAspectRatioClass, 'drop-shadow-visual md:drop-shadow-visual-2': hasShadow }"
        :ignore-default-optmization="noOptmize"
      />
      <video
        v-if="staticVideo"
        ref="ContentBoxVideoAssetVideo"
        playsinline
        muted
        :loop="hasLoop"
        class="absolute inset-0 w-full h-auto"
      >
        <source v-if="isVideoLoaded" :src="staticVideo" type="video/mp4">
      </video>
    </div>
  </div>
</template>

<script>
import { optimize } from '@/utils/image-optimization'
import { isEmpty } from '@/utils/comparators'
export default {
  props: {
    staticVideo: {
      type: String,
      default: () => ''
    },
    staticImage: {
      type: String,
      required: true
    },
    loop: {
      type: Boolean,
      default: () => false
    },
    hasShadow: {
      type: Boolean,
      default: () => false
    },
    imgClass: {
      type: String,
      default: ''
    },
    aspectRatioClass: {
      type: String,
      default: ''
    },
    noOptmize: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      loaded: false,
      isVisible: false,
      isVideoLoaded: false
    }
  },
  computed: {
    optimizedImage () {
      if (this.noOptmize) {
        return this.staticImage
      }

      return optimize(this.staticImage, false, {
        w: 600
        // h: 884,
        // fit: 'crop',
        // crop: 'top'
      })
    },
    hasVideo () {
      return !isEmpty(this.staticVideo)
    },
    hasLoop () {
      return this.loop
        ? 'loop'
        : false
    },
    hasAspectRatioClass () {
      return !isEmpty(this.aspectRatioClass)
    }
  },
  mounted () {
    this.useIntersectionObserverToLoadContent()
    this.useIntersectionObserverToShowContent()
  },
  methods: {
    useIntersectionObserverToLoadContent () {
      try {
        const observer = new IntersectionObserver(this.loadContentCallback, {
          rootMargin: '100px',
          threshold: 0
        })
        observer.observe(this.$refs.ContentBoxVideoAssetWrapper)
      } catch (error) {
        this.isVideoLoaded = true
      }
    },
    useIntersectionObserverToShowContent () {
      try {
        const observer = new IntersectionObserver(this.showContentCallback, {
          threshold: 0.2
        })
        observer.observe(this.$refs.ContentBoxVideoAssetWrapper)
      } catch (error) {
        this.showContentAction()
      }
    },
    loadContentCallback (entries, observer) {
      if (!this.isVideoLoaded) {
        const [entry] = entries
        if (entry && entry.isIntersecting) {
          this.isVideoLoaded = true
        }
      }
    },
    showContentCallback (entries, observer) {
      if (!this.isVisible) {
        const [entry] = entries
        if (entry && entry.isIntersecting) {
          this.showContentAction()
        }
      }
    },
    showContentAction () {
      this.isVisible = true
      if (this.hasVideo) {
        setTimeout(() => {
          if (this.$refs.ContentBoxVideoAssetVideo) { this.$refs.ContentBoxVideoAssetVideo.play() }
        }, 500)
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.no-video {
  max-height: 500px;
  width: auto !important;
  margin-left: auto;
  margin-right: auto;
}

.centralize {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
